import { SDQuerySubscribersStore } from "../SDQuerySubscribersStore";
/**
 * Get previous query from the store
 * @param qPrevID - Stored ID of the previous query
 * @returns {string | undefined}
 */
export function getPrevQuery(qPrevID) {
    return qPrevID && SDQuerySubscribersStore.getQueryByID(qPrevID);
}
/**
 * Get the ID of a previous query that is stored for a connection
 * @param r {object} - Connection
 * @returns {string | undefined}
 */
export function getPrevQueryID(r) {
    const storedQueryForConnection = SDQuerySubscribersStore.getQueryForConnection(r);
    return storedQueryForConnection && SDQuerySubscribersStore.getQueryID(storedQueryForConnection);
}
//# sourceMappingURL=queryGetters.js.map